import type { PropsWithChildren, ReactNode } from 'react'
import { View } from 'react-native'

import { Icon } from '@/src/elements/media/Icon'
import { Typography } from '@/src/elements/text/Typography'
import { ICON } from '@/src/general/enums/icons'

export const MobileMessage = ({ children }: PropsWithChildren): ReactNode => {
  return (
    <View className="relative rounded-md rounded-tl-none bg-secondary-bg-medium px-3 py-2">
      <Icon name={ICON.MESSAGE_TRIANGLE} size="xs" className="text absolute -left-1.5 top-0 text-secondary-bg-medium" />
      <Typography colors="secondary" contrast="high">
        {children}
      </Typography>
    </View>
  )
}
